import { connect } from 'react-redux';
import ArcadeCabinetList from './List';
import { 
    getArcadeCabinets, 
    loadArcadeCabinetForEditing,
    deleteArcadeCabinet
} from '../actions';
import { getArcadeCabinetList  } from '../selectors';

const mapStateToProps = (state) => ({
    list: getArcadeCabinetList(state)
});
const mapDispatchToProps = { 
    getArcadeCabinets, 
    loadArcadeCabinetForEditing,
    deleteArcadeCabinet
};

export default connect(mapStateToProps, mapDispatchToProps)(ArcadeCabinetList);
